import { Users, UserCheck, Wallet, TrendingUp } from "lucide-react";

const KPIS = [
  { key: "clients", label: "Total clients", icon: Users },
  { key: "registered", label: "Registered", icon: UserCheck },
  { key: "deposited", label: "Deposited", icon: Wallet },
  { key: "purchased", label: "Purchased stock", icon: TrendingUp },
];

const pct = (n, d) => (d ? Math.round((n / d) * 100) : 0);

const Kpi = ({ label, icon: Icon, value, total, isBase, testId }) => (
  <div className="rounded-[24px] border border-white/[0.07] bg-surface/70 p-4 sm:p-5" data-testid={testId}>
    <div className="flex items-center justify-between">
      <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400">{label}</p>
      <Icon className="h-4 w-4 text-gold" />
    </div>
    <p className="mt-3 font-display text-3xl font-bold text-zinc-50" data-testid={`${testId}-value`}>{value}</p>
    {!isBase && <p className="mt-1 font-mono text-xs text-zinc-400">{pct(value, total)}% of clients</p>}
  </div>
);

const AdminCard = ({ row, isMe }) => (
  <div className={`rounded-[24px] border p-4 sm:p-5 ${isMe ? "border-gold/30 bg-gold/[0.06]" : "border-white/[0.07] bg-surface/70"}`} data-testid={`crm-admin-summary-${row.admin_id}`}>
    <div className="flex items-center justify-between">
      <p className="font-display text-base font-semibold text-zinc-50">{row.name}{isMe && <span className="ml-2 font-mono text-[11px] text-gold">YOU</span>}</p>
      <p className="font-mono text-sm text-zinc-300"><span className="text-zinc-50">{row.clients}</span> clients</p>
    </div>
    <div className="mt-4 space-y-3">
      {KPIS.slice(1).map((k) => (
        <div key={k.key}>
          <div className="flex justify-between text-xs text-zinc-400">
            <span>{k.label}</span>
            <span className="font-mono text-zinc-200">{row[k.key]}</span>
          </div>
          <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-white/[0.06]">
            <div className="h-full rounded-full bg-gold transition-[width] duration-700" style={{ width: `${pct(row[k.key], row.clients)}%` }} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const CrmSummary = ({ summary, meId }) => {
  const totals = summary?.totals ?? {};
  const perAdmin = Array.isArray(summary?.per_admin) ? summary.per_admin : [];
  return (
    <section data-testid="crm-summary">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {KPIS.map((k) => (
          <Kpi key={k.key} {...k} value={totals[k.key] ?? 0} total={totals.clients ?? 0} isBase={k.key === "clients"} testId={`crm-kpi-${k.key}`} />
        ))}
      </div>
      <div className="mt-3 grid grid-cols-1 gap-3 md:grid-cols-3">
        {perAdmin.map((row) => <AdminCard key={row.admin_id} row={row} isMe={row.admin_id === meId} />)}
      </div>
    </section>
  );
};
